module.exports = __webpack_public_path__ + "assets/images/theLodgeBellingenc652a1a9.png";